import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'crToBr'
})
export class CrToBrPipe implements PipeTransform {

  transform(value: string): string {
    return (value) ? value.replace(/\r\n/g, '<br>').replace(/\r/g, '<br>').replace(/\n/g, '<br>') : '';
  }

}
